// local
// actions
import { pending, rejected, fulfilled } from './async';
import dispatchError from './error';
import { showSnackbar } from './snackbar';
// api
import Supplier from 'app/api/supplier';

export const list = () => dispatch => {
    dispatch(pending('SUPPLIER_LIST'));
    Supplier.list()
        .then(payload => dispatch(fulfilled('SUPPLIER_LIST', payload)))
        .catch(err => {
            dispatch(rejected('SUPPLIER_LIST', err));
            dispatchError(dispatch, err);
        });
};

export const create = data => dispatch => {
    dispatch(pending('SAVE_UPDATE_MODAL'));
    Supplier.create(data)
        .then(payload => {
            dispatch(fulfilled('SAVE_UPDATE_MODAL', payload));
            dispatch({ type: 'SUPPLIER_LIST_CREATE', payload });
            dispatch(showSnackbar({ title: `O fornecedor ${payload.name} foi adicionado com sucesso!`, action: true }));
        })
        .catch(err => {
            dispatch(rejected('SAVE_UPDATE_MODAL', err));
            dispatchError(dispatch, err, false);
        });
};

export const update = (id, data) => dispatch => {
    dispatch(pending('SAVE_UPDATE_MODAL'));
    Supplier.update(id, data)
        .then(payload => {
            dispatch(fulfilled('SAVE_UPDATE_MODAL', payload));
            dispatch({ type: 'SUPPLIER_LIST_UPDATE', payload });
            dispatch(showSnackbar({ title: 'As alterações realizadas foram salvas.', action: true }));
        })
        .catch(err => {
            dispatch(rejected('SAVE_UPDATE_MODAL', err));
            dispatchError(dispatch, err, false);
        });
};

export const search = term => ({
    type: 'SUPPLIER_LIST_SEARCH',
    payload: term,
});

export const reset = () => ({
    type: 'SUPPLIER_LIST_RESET',
});
